import React from 'react'

import * as S from './styled'

const Barra = ({marginBottom}) => <S.BarWrapper style={{marginBottom}} />

export default Barra
